module.exports = __webpack_public_path__ + "static/media/image2.370e7434.jpeg";